"use strict";
/*
 * Created on 19. 9. 2018
 *
 * Copyright (c) 2018 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../../core/conversions/DataObjectConverter");
/**
 * Sellout release item supply data converter.
 *
 * @author Radek Beran
 */


var SelloutReleaseItemSupplyDataConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(SelloutReleaseItemSupplyDataConverter, _DataObjectConverter_);

  function SelloutReleaseItemSupplyDataConverter() {
    _classCallCheck(this, SelloutReleaseItemSupplyDataConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(SelloutReleaseItemSupplyDataConverter).apply(this, arguments));
  }

  return SelloutReleaseItemSupplyDataConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.SelloutReleaseItemSupplyDataConverter = SelloutReleaseItemSupplyDataConverter;